import * as types from "./types";

export const onSaveField = field => {
  return {
    type: types.SAVE_FIELD,
    field
  };
};
export const resetField = () => {
  return {
    type: types.RESET_FIELD
  };
};

export const changeInfoCheckCode = data => {
  return {
    type: types.CHANGE_INFO_CHECK_CODE,
    payload: data
  };
};

export const changeStep = step => {
  return {
    type: types.CHANGE_STEP,
    payload: step
  };
};

export const getDataToRetypeOTP = () => {
  return {
    type: types.GET_DATA_TO_RETYPE_OTP
  };
};

// SAU KHI TÁCH MEDPRO ID
export const redirectToMedproId = () => {
  return {
    type: types.REDIRECT_TO_MEDPRO_ID
  };
};

export const setCurrentDomain = domain => {
  return {
    type: types.SET_CURRENT_URL,
    payload: domain
  };
};
